import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, renderList as _renderList, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "main-container order-edit" }
const _hoisted_2 = {
  key: 1,
  class: "header-actions"
}
const _hoisted_3 = {
  key: 0,
  class: "vip-tag"
}
const _hoisted_4 = { class: "right-actions" }
const _hoisted_5 = {
  key: 0,
  class: "complaint-notice"
}
const _hoisted_6 = { class: "flex-item" }
const _hoisted_7 = { class: "item-images" }
const _hoisted_8 = {
  key: 0,
  class: "action-list"
}
const _hoisted_9 = {
  key: 1,
  class: "refund-text"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 0,
  class: "mt10"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "align-right" }
const _hoisted_18 = { style: {"color":"red"} }
const _hoisted_19 = { style: {"color":"red"} }
const _hoisted_20 = {
  key: 4,
  class: "mt10 align-right"
}
const _hoisted_21 = { class: "logistics-display" }
const _hoisted_22 = { class: "ml20" }
const _hoisted_23 = {
  key: 2,
  class: "font12"
}
const _hoisted_24 = {
  class: "relative",
  style: {"width":"100%"}
}
const _hoisted_25 = {
  key: 0,
  class: "sheep-order-note"
}
const _hoisted_26 = {
  key: 0,
  class: "work-log-container",
  style: {"width":"100%"}
}
const _hoisted_27 = {
  key: 0,
  class: "work-imgs"
}
const _hoisted_28 = {
  key: 1,
  class: "work-input-area",
  style: {"width":"100%"}
}
const _hoisted_29 = { class: "upload-area mt10" }
const _hoisted_30 = { class: "mt10 align-right" }
const _hoisted_31 = {
  key: 0,
  class: "color-danger mr20 bold font18"
}
const _hoisted_32 = {
  key: 1,
  class: "color-danger mr20 bold font18"
}
const _hoisted_33 = { class: "fine-records" }
const _hoisted_34 = { class: "logistics-detail" }
const _hoisted_35 = { class: "summary-box" }
const _hoisted_36 = { class: "logistics-timeline mt10" }
const _hoisted_37 = { class: "cities" }
const _hoisted_38 = {
  key: 0,
  class: "ml20"
}
const _hoisted_39 = ["innerHTML"]

import { ref, reactive, onMounted, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import ImageUploaderDialog from '@/components/upload/Index.vue'
import { openRouteInNewWindow } from '@/utils/router-helper'
import { getAddressCodeApi } from '@/apis/user'
import { getLogisticsInfoApi } from '@/apis/others'
import { getServiceList } from '@/apis/admin'
import { useStore } from '@/store/index'
import { getOrderDetailApi, saveOrderApi, saveFineApi, updateOrderSkuApi, getFineRecordApi, updateFineRecordApi, delFineRecordApi, replyWorkOrderApi, yuanzuPushApi, getYuanzuPushResultApi, getDeliveryShopApi, sendOrderMsgApi, refundApplyRejectApi,adjustOrderItemPriceApi } from '@/apis/order'

enum WorkStatus {
    '待处理',
    '处理中',
    '已处理',
    '已完结',
    '已超时'
}
// 默认赠品

export default /*@__PURE__*/_defineComponent({
  __name: 'Detail',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const orderId = route.query.id as string
const highlightItemId = computed(() => Number(route.query.item_id || 0))
const order_no = route.query.order_no as string

// 判断是否为只读模式 (路由包含 show)
const isReadOnly = computed(() => route.path.includes('show'))
const store = useStore()
const userGroups = store.state.user.userInfo.group_id.split(',')

// 状态定义
const loading = ref(false)
const orderData = ref<any>({
    data: {},
    user: {},
    items: [],
    charges: [],
    brand: {},
    work_res: [{}],
    all_works: [],
    finished_works: [],
    logs: [],
    admins: [],
    db_r: {},
    cities: [],
    areas: [],
    nearby_shops: [],
})

const formData = reactive({
    id: orderId,
    clearing_ship_amount: '',
    refund_price: '',
    refund_type: 1,
    refund_price_msg: '',
    fitting_fee: '',
    delivery_fee: '',
    is_jiesuan: 0,
    ship_type: '',
    ship_date: '',
    ship_time_text: '',
    take_shop_id: '',
    name: '',
    phone: '',
    city: '',
    area: '',
    addr: '',
    brand_order_no: '',
    pay_status: 0,
    shop_status: 0,
    is_hidden: 0,
    status: 0,
    dispose_admin_id: '',
    express_no: '',
    express_cp: '',
    buyer_msg: '',
    seller_msg: '',
    note: '',
    express_code: '',
    express_note: '',
    work_type: '',
    work_level: '',
    work_status: '',
    reply_status: '',
    work_content: '',
    work_image: [] as string[],
    express_take_from: '',
    express_take_to: '',
    update_time: ''
})

const initData = async () => {
    loading.value = true
    const { code, data, msg } = await getOrderDetailApi(orderId, order_no) as any
    if (code != 200) { return ElMessage.error(msg) }

    Object.assign(orderData.value, data)

    // 同步到 formData
    const d = data.data
    Object.assign(formData, {
        clearing_ship_amount: d.clearing_ship_amount,
        refund_price: d.refund_price,
        refund_type: d.refund_type,
        refund_price_msg: d.refund_price_msg,
        fitting_fee: d.fitting_fee,
        delivery_fee: d.delivery_fee,
        is_jiesuan: d.is_jiesuan,
        ship_type: d.ship_type,
        ship_date: d.ship_date,
        ship_time_text: d.ship_time_text,
        take_shop_id: d.take_shop_id,
        name: d.name,
        phone: d.phone,
        city: d.city,
        area: d.area,
        addr: d.addr,
        brand_order_no: d.brand_order_no,
        pay_status: d.pay_status,
        shop_status: d.shop_status,
        is_hidden: d.is_hidden,
        status: d.status,
        dispose_admin_id: d.dispose_admin_id == '0' ? '' : d.dispose_admin_id,
        express_no: d.express_no,
        express_cp: d.express_cp,
        buyer_msg: d.buyer_msg,
        seller_msg: d.seller_msg,
        note: d.note,
        express_code: d.express_code,
        express_note: d.express_note,
        work_type: data?.work_res[0]?.type_id || '',
        work_level: data?.work_res[0]?.work_level || '',
        work_status: data?.work_res[0]?.status || '',
        reply_status: data?.work_res[0]?.reply_status || '',
        express_take_from: d.express_take_from || '',
        express_take_to: d.express_take_to || '',
        update_time: d.updated_at || ''
    })

    // 初始化退款数量输入
    // orderData.value.items.forEach((item: any) => {
    //     item.refund_quantity_input = item.quantity
    // })

    if (highlightItemId.value) {
        setTimeout(() => {
            const el = document.querySelector('.el-table__body tr.highlight-row') as HTMLElement
            if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
        }, 0)
    }
}

/*****************************************  罚款 -- begin *****************************************/
const fineDialogVisible = ref(false)
const fineDialogTitle = ref('罚款信息')
const fineForm = reactive({
    type: 1,
    order_id: '',
    fine_price: '',
    fine_remark: '',
    order_item_id: ''
})
const onFine = (row: any, type: number) => {
    fineForm.type = type
    fineForm.order_item_id = row.id
    fineForm.order_id = orderId
    fineForm.fine_price = ''
    fineForm.fine_remark = ''
    fineDialogTitle.value = type == 1 ? '罚款信息' : type == 2 ? '工单罚款信息' : '超时罚款信息'
    fineDialogVisible.value = true
}
const saveFine = async () => {
    if (!fineForm.fine_price) { return ElMessage.warning('请输入罚款金额') }
    if (!fineForm.fine_remark) { return ElMessage.warning('请输入罚款备注') }

    const { code, data, msg } = await saveFineApi(fineForm) as any
    if (code != 200) { return ElMessage.error(msg) }
    ElMessage.success('罚款成功')
    fineDialogVisible.value = false
    initData()
}
const updateFineDialogVisible = ref(false)
const fineRecords = reactive({
    nofine_record: [],
    fine_record: []
})
const getFineRecord = async (row: any) => {
    const { code, data, msg } = await getFineRecordApi(row.id) as any
    if (code != 200) {
        ElMessage.error(msg || '获取罚款记录失败')
        return
    }
    fineRecords.nofine_record = data.nofine_record
    fineRecords.fine_record = data.fine_record
    updateFineDialogVisible.value = true
}
const saveFineRecords = async () => {
    const updated = fineRecords.fine_record.map((r: any) => ({
        fine_record_id: r.id,
        fine_price: r.money,
        fine_remark: r.reason
    }))
    const { code, data, msg } = await updateFineRecordApi(updated) as any
    if (code != 200) return ElMessage.success(msg)
    ElMessage.success('保存成功')
    updateFineDialogVisible.value = false
    initData()
}
const deleteFineRecord = (row: any) => {
    ElMessageBox.confirm('确定删除该罚款记录吗？', '提示', { type: 'warning' }).then(async () => {
        const { code, data, msg } = await delFineRecordApi(row.id) as any
        if (code != 200) { return ElMessage.error(msg || '删除失败') }
        ElMessage.success('删除成功')
        initData()
        // 重新拉取列表
        const refresh = await getFineRecordApi(row.order_item_id) as any
        fineRecords.fine_record = refresh.data.fine_record
    })
}
/*****************************************  罚款 -- end *****************************************/

/*****************************************  编辑 SKU -- begin *****************************************/
const skuDialogVisible = ref(false)
const skuForm = reactive({
    sku: '',
    item_id: ''
})
const onEditSku = (row: any) => {
    skuForm.sku = row.sku
    skuForm.item_id = row.id
    skuDialogVisible.value = true
}
const onSaveSku = async () => {
    const { code, data, msg } = await updateOrderSkuApi(skuForm.item_id, skuForm.sku) as any
    if (code != 200) { return ElMessage.error(msg || '编辑失败') }
    ElMessage.success('编辑成功')
    skuDialogVisible.value = false
    initData()
}
/*****************************************  编辑 SKU -- end *****************************************/

/*****************************************  修改配送信息 -- begin *****************************************/
const isEditingAddress = ref(false)
const onShipTypeChange = (val: string) => {
    if (val == 'shop') {
        formData.name = orderData.value.data.name
        formData.phone = orderData.value.data.buyer_phone
        formData.ship_date = orderData.value.data.ship_date
        formData.ship_time_text = orderData.value.ship_time_text
        formData.take_shop_id = orderData.value.data.take_shop_id
    } else {
        formData.name = orderData.value.data.name
        formData.phone = orderData.value.data.phone
        formData.city = orderData.value.data.city
        formData.area = orderData.value.data.area
        formData.addr = orderData.value.data.addr
        formData.ship_date = orderData.value.data.ship_date
        formData.ship_time_text = orderData.value.data.ship_time_text
    }
}
const onCityChange = async (val: string) => {
    const cityCode = orderData.value.cities.find((c: any) => c.name == val)?.code
    const { code, data, msg } = await getAddressCodeApi({
        code: cityCode,
        type: 2
    }) as any

    if (code != 200) { return ElMessage.error(msg || '获取地区失败') }

    orderData.value.areas = {}
    data.map(item => {
        orderData.value.areas[item.name] = item.name
    })
    formData.area = data[0]?.name || ''
}
const onUpdateAddr = async () => {
    const params = {
        city: formData.city,
        area: formData.area,
        addr: formData.addr,
        brand_id: orderData.value.brand.id,
        spec_id: orderData.value.items[0]?.spec_id,
        total_amount: orderData.value.data.total_amount,
        ship_amount: orderData.value.data.ship_amount,
        order_id: orderId,
        ship_date: formData.ship_date,
        ship_time_text: formData.ship_time_text,
        name: formData.name,
        phone: formData.phone
    }
    const { code, data, msg } = await getDeliveryShopApi(params) as any
    if (code != 200) { return ElMessage.error(msg || '搜索门店失败') }
    ElMessage.success('操作成功')
    orderData.value.nearby_shops = data.nearby_shops
}
/*****************************************  修改配送信息 -- end *****************************************/

/*****************************************  退款/批量退款 -- begin *****************************************/
// 是否可以整单退款：每一个商品的都是非退款状态（items 的 return_type 为 0）, 且没有用户申请退款记录（order_refund_status = 1 表示有记录，申请后又取消不算。该字段在有过申请记录的情况下才会返回）
const canRefundOrder = computed(() => {
    const items = orderData.value.items
    if (items.some((i: any) => i.return_type != 0)) return false

    if (orderData.value.order_refund_status == 1) return false

    const { data } = orderData.value
    if (data.status == 3 || data.status == 2 || data.pay_status == 0) return false
    
    return true
})
const onOrderRefund = () => {
    openRouteInNewWindow({
        path: '/order/refund',
        query: {
            id: orderId
        }
    })
}
// 是否支持部分退款
const isSupportPartialRefund = computed(() => {
    const { data } = orderData.value
    return ['h5', 'mini_program'].includes(data.channel_no) && data.ship_type == 'same' && data.pay_status == 1
})
const canShowBatchRefund = computed(() => {
    const { data } = orderData.value
    return isSupportPartialRefund.value && data.status != 3 && orderData.value.items.length > 1
})
const showBatchRefund = ref(false)
const onSelectionChange = (val: any[]) => {
    multipleSelection.value = val
}
const isAlreadyRefunded = (item: any) => {
    const { data } = orderData.value
    return data.status == 3 || (item.refund_status && item.refund_status != '待审核' && item.refund_status != '用户取消退款' && item.refund_status != '已寄回') || (item.item_qu_num > 0 && item.status == 3)
}
const getRefundButtonText = (status: string) => {
    const { data } = orderData.value
    if (data.status == 3 || status == '同意' || status == '客服退款完成' || status == '同意退款') return '已退'
    if (status == '驳回') return '驳回'
    if (status == '同意退款') return '退款中'
    return '已退'
}
const getRefundStatusType = (status: string) => {
    if (status == '待审核') return 'danger'
    if (status == '同意' || status == '客服退款完成') return 'success'
    if (status == '驳回') return 'info'
    return 'warning'
}
const formatRefundStatus = (status: string) => {
    if (status == '待审核') return '待处理'
    if (status == '同意' || status == '客服退款完成') return '已处理'
    if (status == '驳回') return '驳回'
    if (status == '同意退款') return '待用户寄回商品'
    if (status == '已寄回') return '用户已寄回商品'
    return status || '--'
}
const canRefundItem = (item: any) => {
    return item.adjust_price == '0.00' && !(item.refund_status && item.refund_status != '待审核' && item.refund_status != '已寄回') && !(item.item_qu_num > 0 && item.status == 3)
}
const multipleSelection = ref<any[]>([])
const toSingleRefund = (row: any) => {
    openRouteInNewWindow({
        path: '/order/refund',
        query: {
            id: orderId,
            item_ids: `${row.id}-${row.quantity}`
        }
    })
}
const toBatchRefund = () => {
    if (multipleSelection.value.length == 0) {
        return ElMessage.warning('请选择要退款的商品')
    }
    // 循环选中的商品，获取所有商品的 item_id 和 数量
    const itemIds = multipleSelection.value.map(item => `${item.id}-${item.quantity}`).join(',')
    openRouteInNewWindow({
        path: '/order/refund',
        query: {
            id: orderId,
            item_ids: itemIds
        }
    })
}
/*****************************************  退款/批量退款 -- end *****************************************/

/*****************************************  查看/修改物流信息 -- begin *****************************************/
const isExpressReadOnly = computed(() => {
    const { data } = orderData.value
    if (!data.express_date) return false
    const date = new Date(data.express_date).getTime()
    return (Date.now() - date) > 72 * 60 * 60 * 1000
})
const logisticsDialogVisible = ref(false)
const currentLogistics = ref<any>({})
const logisticsTraces = reactive({
    fromCity: '',
    list: [] as any[]
})
const viewLogistics = async (log: any) => {
    const { express_cp, express_no  } = log
    const { phone } = orderData.value.data
    currentLogistics.value = log
    const res = await getLogisticsInfoApi(express_cp, express_no, phone) as any
    if (!res.Success) {
        return ElMessage.error(res.Reason)
    }
    logisticsTraces.list = (res.Traces || []).reverse()
    if (logisticsTraces.list.length > 0) {
        logisticsTraces.fromCity = logisticsTraces.list[logisticsTraces.list.length - 1].Location
    }
    logisticsDialogVisible.value = true
}
const formattedLogistics = computed(() => {
    const express_arr: Record<string, any> = {}
    orderData.value.items.forEach((item: any) => {
        if (item.express_no) {
            const nos = item.express_no.replace(/[、\\,，]/g, '/').split('/')
            nos.forEach((no: string) => {
                if (!no) return
                if (express_arr[no]) {
                    express_arr[no].product_name += '、' + item.product_name + `[${item.spec_name}]`
                } else {
                    express_arr[no] = {
                        express_cp: item.express_cp,
                        express_no: no,
                        ship_time: item.ship_time,
                        product_name: item.product_name + `[${item.spec_name}]`,
                        phone: orderData.value.data.phone
                    }
                }
            })
        }
    })
    return Object.values(express_arr)
})
/*****************************************  查看/修改物流信息 -- end *****************************************/

/*****************************************  工单回复 -- begin *****************************************/
const isWorkOrderProcessed = computed(() => orderData.value.work_res[0]?.type_id > 0)
const replyDialogVisible = ref(false)
const replyForm = reactive({
    content: '',
    images: [] as string[]
})
const confirmReply = async () => {
    if (!replyForm.content.trim()) return ElMessage.warning('请填写回复内容')
    try {
        const res = await replyWorkOrderApi(orderData.value.work_res[0]?.id, replyForm.content, replyForm.images.join(',')) as any
        if (res.code == 200) {
            ElMessage.success('回复成功')
            replyDialogVisible.value = false
            initData()
        } else {
            ElMessage.error(res.msg)
        }
    } catch (err) {
        ElMessage.error('回复失败')
    }
}
/*****************************************  工单回复 -- end *****************************************/

/*****************************************  获取客服列表 -- begin *****************************************/
const isAdmin = computed(() => orderData.value.admin?.id == 4 || true) // 简化处理
const onGetAdminList = async () => {
    const { code, data, msg } = await getServiceList() as any
    if (code != 200) { return ElMessage.error(msg) }
    orderData.value.admins = data
}
onGetAdminList()
/*****************************************  获取客服列表 -- end *****************************************/

/*****************************************  元祖订单推送 -- begin *****************************************/
const yuanzuPush = async () => {
    const { code, data, msg } = await yuanzuPushApi(orderId) as any
    if (code != 200) { return ElMessage.error(msg) }
    ElMessage.success('推送成功')
}
const viewPushResult = async () => {
    const { code, data, msg } = await getYuanzuPushResultApi(orderId) as any
    if (code != 200) { return ElMessage.error(msg) }
    ElMessageBox.alert(data.push_data.description, '推送结果')
}
/*****************************************  元祖订单推送 -- end *****************************************/

/*****************************************  差价 -- begin *****************************************/
const priceDialogVisible = ref(false)
const priceForm = reactive({
    price_diff: '',
    price_remark: '',
    item_id: '',
    type: 1
})

const onEditPrice = (item: any) => {
    priceForm.price_diff = item.price_diff || '-'
    priceForm.price_remark = item.price_remark || ''
    priceForm.item_id = item.id
    priceDialogVisible.value = true
}

const validatePriceDiff = () => {
    // 确保输入是数字格式，允许 -、+、. 和数字
    priceForm.price_diff = priceForm.price_diff.replace(/[^-+\d.]/g, '')
}

const savePriceDiff = async () => {
    if (!priceForm.price_diff) {
        return ElMessage.warning('请输入差价')
    }
    if (!priceForm.price_remark) {
        return ElMessage.warning('请输入差价备注')
    }
    
    // 检查差价绝对值是否大于商品总计
    const item = orderData.value.items.find((i: any) => i.id == priceForm.item_id)
    if (item) {
        const diffValue = Math.abs(parseFloat(priceForm.price_diff))
        const totalValue = parseFloat(item.final_amount)
        if (diffValue > totalValue) {
            return ElMessage.warning('差价金额不得大于商品总计')
        }
    }
    
    const res = await adjustOrderItemPriceApi({
        order_id: orderId,
        item_id: priceForm.item_id,
        adjust_price: parseFloat(priceForm.price_diff),
        remark: priceForm.price_remark,
        type: priceForm.type   /// 1: 余额，2: 实付（客服操作）
    }) as any
    if (res.code != 200) { return ElMessage.error(res.msg) }
    ElMessage.success('差价保存成功')
    priceDialogVisible.value = false
    // 刷新数据
    initData()
}

const formatAdjustPrice = (price: string | number) => {
    if (!price) return '0.00'
    const num = parseFloat(String(price))
    if (num > 0) {
        return '-' + num.toFixed(2)
    } else if (num < 0) {
        return '+' + Math.abs(num).toFixed(2)
    }
    return '0.00'
}

/*****************************************  差价 -- end *****************************************/
// 工单状态
const giftItems = computed(() => orderData.value.items.filter((i: any) => i.spec?.gift))
// 是否为测试订单
const isTestOrder = computed(() => orderData.value.data.buyer_msg?.includes('测试订单'))
// 是否为羊毛单
const isSheepOrder = computed(() => {
    const ids = ['2303575','2311806','2311938','2312164','2312465','2314026','2314374','2314384','2314490','2314571','2314605','2314644','2314924','2314945','2315868','2316208','2316731','2316861','2317472','2317592','2317708','2318801','2319059','2319460','2319467','2319469','2321093','2321167','2321179','2321191','2321211','2321225','2321226','2321229','2321235','2321247','2321249','2321250','2321251','2321264','2321268','2321271','2321278','2321291','2321296','2321342','2321344','2321351','2321375','2321376','2321378','2321387','2321389','2321390','2321391','2321396','2321399','2321417','2321432','2321434','2321436','2321438','2321444','2321459','2321460','2321461','2321464','2321492','2321560','2321609','2321645','2321651','2321655','2321656','2321657','2321658','2321662','2321664','2321665','2321714','2321715','2321730','2321731','2321733','2321757','2321803','2321813','2321814','2321815','2321820','2321833','2321835','2321839','2321855','2321861','2321875','2321906','2321909','2321910','2321916','2321917','2321925','2321926','2321953','2321993','2321994','2322002','2322012','2322018','2322030','2322073','2322075','2322083','2322111','2322113','2322114','2322115','2322116','2322117','2322118','2322119','2322129','2322131','2322170','2322175','2322185','2322192','2322486','2322519','2322520','2322528','2322546','2322549','2322559','2322566','2322606','2322667','2322670','2322682','2322685','2322700','2322701','2322702','2322707','2323128','2323888','2324038','2324082','2324136','2324137','2324158','2324219','2324224','2324225','2324233','2324245','2324252','2324259','2324266','2324269','2324275','2324276','2324292','2324304','2324305','2324313','2324335','2324385','2324395','2324404','2324414','2324417','2324421','2324436','2324445','2324453','2324456','2324463','2324465','2324469','2324491','2324504','2324505','2324508','2324509','2324515','2324516','2324519','2324541','2324542','2324550','2324552','2324566','2324578','2324588','2324604','2324606','2324612']
    return ids.includes(String(orderData.value.data.id))
})
// 获取商品链接
const getProductLink = (id: number) => `https://www.dangaoss.com/h5/product/show?id=${id}`
// 格式化用户姓名
const formatUserName = (user: any, data: any) => {
    if (!user) return ''
    const isBind = data.ship_type == 'shop' && user.login_type == 1 && user.is_bind == 0
    const prefix = isBind ? data.buyer_phone : user.username
    return `${prefix} (姓名: ${user.name || '无'})`
}
// 格式化收费附件金额
const formatCharge = (charge: any) => {
    const remark = charge.remark || '无'
    return `名称：${charge.charge_name} 数量：${charge.quantity}(${charge.charge_unity}) 金额：${charge.total_amount} 备注：${remark}`
}
// 格式化订单金额
const formatOrderAmount = (data: any, chargeAmount: number) => {
    return `总额：${data.total_amount}；运费：${data.ship_amount}；附件：${chargeAmount || '0.00'}；实付：${data.final_amount}；通用余额：${data.user_money_paid}；蛋糕卡余额：${data.cake_money_paid}；生活卡余额：${data.life_money_paid}；礼券：${data.coupon_paid}；红包：${data.user_red_paid}；活动：${data.promotion_paid}；权益：${data.equaty_paid}；实付满减：${data.wechat_reduce || '0.00'}`
}
// 格式化配送信息
const formatDeliveryInfo = (data: any) => {
    const shipTime = (data.ship_time_text || '').replace(/[\t\n\r]/g, '')
    const addr = (data.addr || '').replace(/\s+/g, '')
    let res = `姓名：${data.name}\n电话：${data.phone}\n地址: ${data.province} ${data.city} ${data.area} ${addr}\n送货时间：${data.ship_date} ${shipTime}`
    if (data.channel_no == 'jingdongdaojia') {
        res += `\n用户备注：${data.buyer_msg}`
    }
    return res
}
// 格式化配送轨迹
const formatTrace = (station: string) => {
    return station.replace(/【/g, '<span class="color-weight">【').replace(/】/g, '】</span>')
}
// 复制订单退款链接
const copyRefundList = () => {
    const link = `https://www.dangaoss.com/h5/order/show?id=${orderId}`

    const input = document.createElement('textarea')
    input.value = link
    document.body.appendChild(input)
    input.select()
    if (document.execCommand('copy')) {
        ElMessage.success('复制成功')
    } else {
        ElMessage.error('复制失败')
    }
    document.body.removeChild(input)
}
// 复制所有订单信息
const copyAllInfo = () => {
    const { data } = orderData.value
    const shipType = data.ship_type == 'shop' ? '自提' : '送货上门'
    let extraInfo = ''
    if (data.ship_type == 'shop') {
        const shop = orderData.value.shop
        extraInfo = `自提时间: ${data.ship_date} ${data.ship_time_text}\n自提门店信息: ${shop.name} | ${shop.address} | ${shop.phone} | 自提人姓名：${data.name} | 自提人电话：${data.buyer_phone}\n门店地址: ${data.province}-${data.city}-${data.area}`
    } else {
        const deliveryInfo = formatDeliveryInfo(data)
        const selectedShop = orderData.value.nearby_shops.find((s: any) => s.shop_id == formData.take_shop_id)
        const shopName = selectedShop ? selectedShop.shop_name : '无'
        extraInfo = `门店地址: ${data.province}-${data.city}-${data.area}\n${deliveryInfo}\n配送门店: ${shopName}`
    }

    let productInfo = '商品信息:\n'
    orderData.value.items.forEach((item: any) => {
        productInfo += `品牌：${orderData.value.brand.name} | 商品：${item.product_name} | 规格：${item.spec_name}${item.spec?.description}${item.tastes} | 数量：${item.quantity} | 总计：${item.final_amount}\n`
    })

    const chargeInfo = orderData.value.charges.length ? orderData.value.charges.map(formatCharge).join('\n') : '收费附件:\n无'
    const userRemark = `\n用户备注：\n${data.buyer_msg || '无'}`

    const allInfo = `订单号: ${data.order_no}\n配送方式: ${shipType}\n${extraInfo}\n${productInfo}\n${chargeInfo}${userRemark}`
    
    const input = document.createElement('textarea')
    input.value = allInfo
    document.body.appendChild(input)
    input.select()
    if (document.execCommand('copy')) {
        ElMessage.success('复制成功')
    } else {
        ElMessage.error('复制失败')
    }
    document.body.removeChild(input)
}
// 发送短信模板
const sendSms = async () => {
    const { express_no, phone } = orderData.value.data
    if (!express_no || !phone) return ElMessage.warning('未获取快递单号或手机号')
    const { code, data, msg } = await sendOrderMsgApi(express_no, phone) as any
    if (code != 200) return ElMessage.error(msg)
    ElMessage.success('短信发送成功')
}
const serviceAddrRejectReason = ref('')
const onAllowServiceAddr = () => {
    ElMessage.success('已允许修改')
}
const onRejectServiceAddr = async () => {
    if (!serviceAddrRejectReason.value.trim()) return ElMessage.warning('请填写驳回理由')
    const { code, data, msg } = await refundApplyRejectApi(orderData.value.service_addr.id, serviceAddrRejectReason.value) as any
    if (code != 200) return ElMessage.error(msg)
    ElMessage.success('已驳回修改')
    initData()
}
// 保存订单
const submitForm = async () => {
    if (Number(formData.refund_price) > 0) {
        if (!formData.refund_type || formData.refund_type < 1) return ElMessage.warning('请选择补偿承担方')
        if (!formData.refund_price_msg.trim()) return ElMessage.warning('请输入补偿金额备注')
    }
    // 距离校验逻辑
    const selectedShop = orderData.value.nearby_shops.find((s: any) => s.shop_id == formData.take_shop_id)
    if (selectedShop && selectedShop.distance) {
        const distStr = selectedShop.distance.toLowerCase()
        if (distStr.includes('km')) {
            const km = parseFloat(distStr)
            const brandName = orderData.value.brand.name
            if (['元祖', '味多美', '维尔纳斯'].includes(brandName) && km > 3) {
                await ElMessageBox.confirm('分配的门店距离大于3公里', '提示', { type: 'warning' })
            }
        }
    }

    const { code, data, msg } = await saveOrderApi(formData) as any
    if (code != 200) { return ElMessage.error(msg) }

    ElMessage.success('保存成功')
    
    // 通知列表更新数据并关闭当前窗口
    const orderChannel = new BroadcastChannel('order-channel')
    orderChannel.postMessage({ type: 'REFRESH_LIST' })
    orderChannel.close()

    setTimeout(() => {
        window.close()
    }, 1500)
}
// 保存并生成工单
const submitFormWithWorkOrder = () => {
    if (!formData.work_type) return ElMessage.warning('请选择工单类别')
    if (!formData.work_level) return ElMessage.warning('请选择工单优先级')
    if (!formData.work_content.trim()) return ElMessage.warning('请输入工单内容')
    submitForm()
}
// 跳转至用户余额日志
const toUserBalanceLog = () => {
    router.push(`/user/user-log?id=${orderData.value.user.id}`)
}

const itemRowClassName = ({ row }) => {
    return highlightItemId.value && row.id == highlightItemId.value ? 'highlight-row' : ''
}

onMounted(() => {
    initData()
})

return (_ctx: any,_cache: any) => {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _directive_decimal = _resolveDirective("decimal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      model: formData,
      "label-width": "120px",
      class: "form-edit",
      disabled: isReadOnly.value
    }, {
      default: _withCtx(() => [
        (orderData.value.if_guangfa)
          ? (_openBlock(), _createBlock(_component_el_alert, {
              key: 0,
              type: "error",
              closable: false,
              class: "mb10"
            }, {
              default: _withCtx(() => _cache[74] || (_cache[74] = [
                _createTextVNode(" 该订单为广发定制：非质量问题，概不退货 ")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true),
        (orderData.value.user?.member_id > 0 || orderData.value.user?.complaint_number > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (orderData.value.user?.member_id > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, "尊贵的VIP用户"))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_4, [
                (orderData.value.user?.complaint_number > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, " （本用户一年内投诉" + _toDisplayString(orderData.value.user.complaint_number) + "次） ", 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_card, { shadow: "hover" }, {
          header: _withCtx(() => [
            _createVNode(_component_el_row, {
              justify: "space-between",
              align: "middle"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => _cache[75] || (_cache[75] = [
                    _createTextVNode("订单基本信息")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 6,
                  class: "align-right"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small",
                      onClick: copyRefundList
                    }, {
                      default: _withCtx(() => _cache[76] || (_cache[76] = [
                        _createTextVNode("复制订单退款链接")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small",
                      onClick: copyAllInfo
                    }, {
                      default: _withCtx(() => _cache[77] || (_cache[77] = [
                        _createTextVNode("一键复制订单信息")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "订单号" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: orderData.value.data.order_no,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((orderData.value.data.order_no) = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "第三方订单号" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: orderData.value.data.out_order_no,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((orderData.value.data.out_order_no) = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "兑换码" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: orderData.value.data.coupon_no,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((orderData.value.data.coupon_no) = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "订单来源" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: orderData.value.data.channel_name,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((orderData.value.data.channel_name) = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "下单人手机号" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: orderData.value.data.buyer_phone,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((orderData.value.data.buyer_phone) = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "收货人手机号" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: orderData.value.data.phone,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((orderData.value.data.phone) = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "用户" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          value: formatUserName(orderData.value.user, orderData.value.data),
                          disabled: ""
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "客户来源" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          value: orderData.value.user?.sale_channel || orderData.value.user?.channel_no,
                          disabled: ""
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "下单时间" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: orderData.value.data.created_at,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((orderData.value.data.created_at) = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "蛋叔userid" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: orderData.value.data.buyer_id,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((orderData.value.data.buyer_id) = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "我方购物车号" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: orderData.value.data.cart_order_no,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((orderData.value.data.cart_order_no) = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "用户当前余额" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_el_input, {
                            modelValue: orderData.value.all_money,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((orderData.value.all_money) = $event)),
                            disabled: ""
                          }, {
                            append: _withCtx(() => _cache[78] || (_cache[78] = [
                              _createTextVNode("元")
                            ])),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_el_button, {
                            type: "primary",
                            class: "ml10",
                            onClick: toUserBalanceLog
                          }, {
                            default: _withCtx(() => _cache[79] || (_cache[79] = [
                              _createTextVNode("余额日志")
                            ])),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, {
          shadow: "hover",
          header: "商品信息",
          class: "mt10"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table, {
              data: orderData.value.items,
              border: "",
              style: {"width":"100%"},
              onSelectionChange: onSelectionChange,
              "row-class-name": itemRowClassName
            }, {
              default: _withCtx(() => [
                (showBatchRefund.value)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 0,
                      type: "selection",
                      width: "55",
                      selectable: canRefundItem
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_table_column, {
                  label: "品牌",
                  prop: "brand_name"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(orderData.value.brand?.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "商品",
                  width: "200"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_link, {
                      type: "primary",
                      href: getProductLink(scope.row.product_id),
                      target: "_blank"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scope.row.product_name), 1)
                      ]),
                      _: 2
                    }, 1032, ["href"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { label: "规格" }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.spec_name) + _toDisplayString(scope.row.spec?.description) + _toDisplayString(scope.row.tastes), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "数量",
                  prop: "quantity",
                  width: "80"
                }),
                _createVNode(_component_el_table_column, {
                  label: "总计",
                  prop: "final_amount",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  label: "差价",
                  width: "100"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(formatAdjustPrice(scope.row.adjust_price)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "差价备注",
                  prop: "remark"
                }),
                (isSupportPartialRefund.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_el_table_column, {
                        label: "退款操作",
                        width: "120"
                      }, {
                        default: _withCtx((scope) => [
                          (isAlreadyRefunded(scope.row))
                            ? (_openBlock(), _createBlock(_component_el_tag, {
                                key: 0,
                                type: getRefundStatusType(scope.row.refund_status)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(getRefundButtonText(scope.row.refund_status)), 1)
                                ]),
                                _: 2
                              }, 1032, ["type"]))
                            : (_openBlock(), _createBlock(_component_el_tooltip, {
                                key: 1,
                                content: '产生差价的商品不可以退款',
                                placement: "top",
                                disabled: scope.row.adjust_price == '0.00'
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    size: "small",
                                    disabled: scope.row.adjust_price != '0.00',
                                    onClick: ($event: any) => (toSingleRefund(scope.row))
                                  }, {
                                    default: _withCtx(() => _cache[80] || (_cache[80] = [
                                      _createTextVNode("退款")
                                    ])),
                                    _: 2
                                  }, 1032, ["disabled", "onClick"])
                                ]),
                                _: 2
                              }, 1032, ["disabled"]))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "退款数量",
                        prop: "quantity",
                        width: "150"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "退款备注",
                        prop: "refund_remark"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "退款状态",
                        width: "120"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("span", {
                            class: _normalizeClass({'color-danger': scope.row.refund_status == '待审核'})
                          }, _toDisplayString(formatRefundStatus(scope.row.refund_status)), 3)
                        ]),
                        _: 1
                      })
                    ], 64))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_table_column, {
                  label: "图片",
                  width: "100"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", _hoisted_7, [
                      (scope.row.diy_image_ids)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(scope.row.diy_images, (img, index) => {
                            return (_openBlock(), _createBlock(_component_el_image, {
                              key: index,
                              src: img.s_path,
                              "preview-src-list": [img.o_path],
                              class: "mini-img"
                            }, null, 8, ["src", "preview-src-list"]))
                          }), 128))
                        : (_openBlock(), _createBlock(_component_el_image, {
                            key: 1,
                            src: scope.row.image_path,
                            "preview-src-list": [scope.row.image_path],
                            class: "mini-img",
                            "preview-teleported": true
                          }, null, 8, ["src", "preview-src-list"]))
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "商家罚款/赔付",
                  prop: "compensation",
                  width: "120"
                }),
                (orderData.value.brand?.id != 79 && orderData.value.brand?.id != 102785 && orderData.value.brand?.id != 102788)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 2,
                      label: "sku编码",
                      prop: "sku",
                      width: "120"
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_table_column, {
                  label: "操作",
                  fixed: "right",
                  width: "240"
                }, {
                  default: _withCtx((scope) => [
                    (!isReadOnly.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            size: "small",
                            class: "mb10",
                            onClick: ($event: any) => (onFine(scope.row, 1))
                          }, {
                            default: _withCtx(() => _cache[81] || (_cache[81] = [
                              _createTextVNode("罚款")
                            ])),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_el_button, {
                            type: "primary",
                            size: "small",
                            class: "mb10",
                            onClick: ($event: any) => (onFine(scope.row, 3))
                          }, {
                            default: _withCtx(() => _cache[82] || (_cache[82] = [
                              _createTextVNode("超时罚款")
                            ])),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_el_button, {
                            type: "primary",
                            size: "small",
                            class: "mb10",
                            onClick: ($event: any) => (onFine(scope.row, 2))
                          }, {
                            default: _withCtx(() => _cache[83] || (_cache[83] = [
                              _createTextVNode("工单罚款")
                            ])),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_el_button, {
                            type: "primary",
                            size: "small",
                            onClick: ($event: any) => (onEditSku(scope.row))
                          }, {
                            default: _withCtx(() => _cache[84] || (_cache[84] = [
                              _createTextVNode("编辑SKU")
                            ])),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_el_button, {
                            type: "primary",
                            size: "small",
                            onClick: ($event: any) => (getFineRecord(scope.row))
                          }, {
                            default: _withCtx(() => _cache[85] || (_cache[85] = [
                              _createTextVNode("修改罚款")
                            ])),
                            _: 2
                          }, 1032, ["onClick"]),
                          ((orderData.value.data.pay_status == 1 && orderData.value.data.status != 3))
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                type: "primary",
                                size: "small",
                                onClick: ($event: any) => (onEditPrice(scope.row))
                              }, {
                                default: _withCtx(() => _cache[86] || (_cache[86] = [
                                  _createTextVNode("差价")
                                ])),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("template", null, [
                            (scope.row.return_type == 0)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  type: "primary",
                                  size: "small",
                                  onClick: ($event: any) => (toSingleRefund(scope.row))
                                }, {
                                  default: _withCtx(() => _cache[87] || (_cache[87] = [
                                    _createTextVNode("退款")
                                  ])),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : (scope.row.return_type == 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_9, "已退款"))
                                : _createCommentVNode("", true)
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_10, "--"))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"]),
            (canShowBatchRefund.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (orderData.value.items?.every(item => item.adjust_price != '0.00'))
                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 0,
                        content: "订单中的商品存在差价变动，不可以退款",
                        placement: "top"
                      }, {
                        default: _withCtx(() => [
                          (!showBatchRefund.value)
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                type: "primary",
                                size: "small",
                                disabled: ""
                              }, {
                                default: _withCtx(() => _cache[88] || (_cache[88] = [
                                  _createTextVNode("批量退款")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : (!showBatchRefund.value)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          type: "primary",
                          size: "small",
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (showBatchRefund.value = true))
                        }, {
                          default: _withCtx(() => _cache[89] || (_cache[89] = [
                            _createTextVNode("批量退款")
                          ])),
                          _: 1
                        }))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createVNode(_component_el_button, {
                            type: "default",
                            size: "small",
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (showBatchRefund.value = false))
                          }, {
                            default: _withCtx(() => _cache[90] || (_cache[90] = [
                              _createTextVNode("取消批量退款")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_el_button, {
                            type: "primary",
                            size: "small",
                            onClick: toBatchRefund
                          }, {
                            default: _withCtx(() => _cache[91] || (_cache[91] = [
                              _createTextVNode("提交批量退款")
                            ])),
                            _: 1
                          })
                        ], 64))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, {
          shadow: "hover",
          header: "附加信息",
          class: "mt10"
        }, {
          default: _withCtx(() => [
            (orderData.value.data.brand_order_no)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "第三方品牌订单号"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      value: orderData.value.data.brand_order_no,
                      disabled: "",
                      class: "mb5"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, { label: "品牌备注" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  class: "full-width",
                  rows: 3,
                  modelValue: orderData.value.brand.remarks,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((orderData.value.brand.remarks) = $event)),
                  readonly: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "默认赠品" }, {
              default: _withCtx(() => [
                (giftItems.value.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(giftItems.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        style: {"width":"100%"}
                      }, [
                        _createVNode(_component_el_input, {
                          value: item.spec?.gift,
                          disabled: "",
                          class: "mb5 full-width"
                        }, null, 8, ["value"])
                      ]))
                    }), 128))
                  : (_openBlock(), _createElementBlock("div", _hoisted_12, _cache[92] || (_cache[92] = [
                      _createElementVNode("span", null, "无", -1)
                    ])))
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "收费附件" }, {
              default: _withCtx(() => [
                (orderData.value.charges?.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(orderData.value.charges, (charge, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "mb5",
                        style: {"display":"block","width":"100%"}
                      }, [
                        _createVNode(_component_el_input, {
                          value: formatCharge(charge),
                          disabled: ""
                        }, null, 8, ["value"])
                      ]))
                    }), 128))
                  : (_openBlock(), _createElementBlock("div", _hoisted_13, _cache[93] || (_cache[93] = [
                      _createElementVNode("span", null, "无", -1)
                    ])))
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "订单金额" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  class: "full-width",
                  rows: 2,
                  value: formatOrderAmount(orderData.value.data, orderData.value.charge_amount),
                  disabled: ""
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, {
          shadow: "hover",
          header: "结算与补偿",
          class: "mt10"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "结算运费" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formData.clearing_ship_amount,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.clearing_ship_amount) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "额外配件费" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formData.fitting_fee,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.fitting_fee) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "额外运费" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formData.delivery_fee,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formData.delivery_fee) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "补偿客户金额" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formData.refund_price,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formData.refund_price) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "补偿承担方" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio_group, {
                          modelValue: formData.refund_type,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formData.refund_type) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio, { label: "1" }, {
                              default: _withCtx(() => _cache[94] || (_cache[94] = [
                                _createTextVNode("平台承担")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_el_radio, { label: "2" }, {
                              default: _withCtx(() => _cache[95] || (_cache[95] = [
                                _createTextVNode("商家承担")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _cache[96] || (_cache[96] = _createElementVNode("span", { class: "sub-tip" }, "注：商家承担进入商家罚款", -1))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "补偿备注" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "textarea",
                          rows: 2,
                          modelValue: formData.refund_price_msg,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formData.refund_price_msg) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (orderData.value.data.pay_status == 1 && orderData.value.data.status == 3)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "是否正常结算"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_group, {
                      modelValue: formData.is_jiesuan,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formData.is_jiesuan) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio, { label: "0" }, {
                          default: _withCtx(() => _cache[97] || (_cache[97] = [
                            _createTextVNode("否")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_el_radio, { label: "1" }, {
                          default: _withCtx(() => _cache[98] || (_cache[98] = [
                            _createTextVNode("是")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, {
          shadow: "hover",
          header: "配送信息",
          class: "mt10 relative"
        }, {
          default: _withCtx(() => [
            (!isReadOnly.value)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  size: "small",
                  class: "abs-right-top",
                  onClick: _cache[20] || (_cache[20] = ($event: any) => (isEditingAddress.value = !isEditingAddress.value))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(isEditingAddress.value ? '取消修改' : '修改配送信息'), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, { label: "配送方式" }, {
              default: _withCtx(() => [
                (isEditingAddress.value)
                  ? (_openBlock(), _createBlock(_component_el_select, {
                      key: 0,
                      modelValue: formData.ship_type,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((formData.ship_type) = $event)),
                      onChange: onShipTypeChange
                    }, {
                      default: _withCtx(() => [
                        (orderData.value.db_r.can_stable)
                          ? (_openBlock(), _createBlock(_component_el_option, {
                              key: 0,
                              value: "stable",
                              label: "送货上门"
                            }))
                          : _createCommentVNode("", true),
                        (orderData.value.db_r.can_same)
                          ? (_openBlock(), _createBlock(_component_el_option, {
                              key: 1,
                              value: "same",
                              label: "送货上门"
                            }))
                          : _createCommentVNode("", true),
                        (orderData.value.db_r.can_ship)
                          ? (_openBlock(), _createBlock(_component_el_option, {
                              key: 2,
                              value: "delivery",
                              label: "送货上门"
                            }))
                          : _createCommentVNode("", true),
                        (orderData.value.db_r.can_take || orderData.value.data.ship_type == 'shop')
                          ? (_openBlock(), _createBlock(_component_el_option, {
                              key: 3,
                              value: "shop",
                              label: "自提"
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : (_openBlock(), _createBlock(_component_el_input, {
                      key: 1,
                      value: orderData.value.data.ship_type == 'shop' ? '自提' : '送货上门',
                      disabled: ""
                    }, null, 8, ["value"]))
              ]),
              _: 1
            }),
            (formData.ship_type == 'shop')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_el_form_item, { label: "自提时间" }, {
                    default: _withCtx(() => [
                      (isEditingAddress.value)
                        ? (_openBlock(), _createBlock(_component_el_row, {
                            key: 0,
                            gutter: 10,
                            style: {"width":"350px"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 12 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: formData.ship_date,
                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((formData.ship_date) = $event)),
                                    placeholder: "日期"
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderData.value.db_r?.validate_take_dates, (d) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: d.date,
                                          label: d.date_text,
                                          value: d.date
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 12 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: formData.ship_time_text,
                                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((formData.ship_time_text) = $event)),
                                    placeholder: "时间"
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderData.value.db_r?.validate_take_times, (t) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: t.text,
                                          label: t.text,
                                          value: t.text
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_el_input, {
                            key: 1,
                            value: orderData.value.data.ship_date + ' ' + orderData.value.data.ship_time_text,
                            disabled: ""
                          }, null, 8, ["value"]))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "自提门店" }, {
                    default: _withCtx(() => [
                      (isEditingAddress.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createVNode(_component_el_radio_group, {
                              modelValue: formData.take_shop_id,
                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((formData.take_shop_id) = $event))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderData.value.nearby_shops, (s) => {
                                  return (_openBlock(), _createBlock(_component_el_radio, {
                                    key: s.shop_id,
                                    label: s.shop_id
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(s.shop_name) + " (" + _toDisplayString(s.distance) + ") " + _toDisplayString(s.phone), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["label"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("p", null, "门店名称：" + _toDisplayString(orderData.value.shop?.name), 1),
                            _createElementVNode("p", null, "门店地址：" + _toDisplayString(orderData.value.shop?.address), 1),
                            _createElementVNode("p", null, "门店电话：" + _toDisplayString(orderData.value.shop?.phone), 1),
                            _createElementVNode("p", null, "自提人：" + _toDisplayString(orderData.value.data.name), 1),
                            _createElementVNode("p", null, "自提电话：" + _toDisplayString(orderData.value.data.buyer_phone), 1)
                          ]))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "门店详细地址" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "textarea",
                        disabled: "",
                        autosize: "",
                        class: "full-width",
                        "model-value": `${orderData.value.shop?.province}-${orderData.value.shop?.city}-${orderData.value.shop?.address}`
                      }, null, 8, ["model-value"])
                    ]),
                    _: 1
                  })
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  (isEditingAddress.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createVNode(_component_el_row, { gutter: 10 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, { label: "姓名" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: formData.name,
                                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((formData.name) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, { label: "电话" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: formData.phone,
                                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((formData.phone) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_row, { gutter: 10 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, { label: "城市" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: formData.city,
                                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((formData.city) = $event)),
                                      filterable: "",
                                      onChange: onCityChange
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderData.value.cities, (city) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: city.id,
                                            label: city.name,
                                            value: city.name
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, { label: "区县" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: formData.area,
                                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((formData.area) = $event)),
                                      filterable: ""
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderData.value.areas, (a) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: a,
                                            label: a,
                                            value: a
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "地址" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formData.addr,
                              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((formData.addr) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_row, { gutter: 10 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, { label: "送货日期" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: formData.ship_date,
                                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((formData.ship_date) = $event))
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderData.value.db_r?.validate_delivery_dates, (d) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: d.date,
                                            label: d.date_text,
                                            value: d.date
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, { label: "送货时间" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: formData.ship_time_text,
                                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((formData.ship_time_text) = $event))
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderData.value.db_r?.validate_delivery_times, (t) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: t.text,
                                            label: t.text,
                                            value: t.text
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            size: "small",
                            onClick: onUpdateAddr
                          }, {
                            default: _withCtx(() => _cache[99] || (_cache[99] = [
                              _createTextVNode("确认修改")
                            ])),
                            _: 1
                          })
                        ])
                      ]))
                    : (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 1,
                        label: "送货信息"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            type: "textarea",
                            class: "full-width",
                            rows: 5,
                            value: formatDeliveryInfo(orderData.value.data),
                            disabled: ""
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })),
                  _createVNode(_component_el_form_item, { label: "配送门店" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_group, {
                        modelValue: formData.take_shop_id,
                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((formData.take_shop_id) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderData.value.nearby_shops, (ns) => {
                            return (_openBlock(), _createBlock(_component_el_radio, {
                              key: ns.shop_id,
                              label: ns.shop_id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(ns.shop_name) + " (" + _toDisplayString(ns.distance) + ") " + _toDisplayString(ns.phone), 1)
                              ]),
                              _: 2
                            }, 1032, ["label"]))
                          }), 128)),
                          (orderData.value.brand?.id == 101634)
                            ? (_openBlock(), _createBlock(_component_el_radio, {
                                key: 0,
                                label: "1125325"
                              }, {
                                default: _withCtx(() => _cache[100] || (_cache[100] = [
                                  _createTextVNode("cakeboss（广州） 400-889-8188")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ], 64)),
            (orderData.value.service_addr && !Array.isArray(orderData.value.service_addr))
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 3,
                  label: "退款审核"
                }, {
                  default: _withCtx(() => [
                    (orderData.value.service_addr.type == 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_el_row, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(orderData.value.service_addr.status == 1 ? '用户新地址' : (orderData.value.service_addr.status == 2 ? '用户修改前地址' : '用户提交地址')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_input, {
                            type: "textarea",
                            disabled: "",
                            autosize: "",
                            class: "full-width mt10",
                            "model-value": `姓名：${orderData.value.service_addr_list?.name || ''}    电话：${orderData.value.service_addr_list?.phone || ''}    地址: ${orderData.value.service_addr_list?.province || ''} ${orderData.value.service_addr_list?.city || ''} ${orderData.value.service_addr_list?.area || ''} ${orderData.value.service_addr_list?.addr || ''}    用户提交时间: ${orderData.value.service_addr?.created_at || ''}`
                          }, null, 8, ["model-value"]),
                          (orderData.value.service_addr.status == 1)
                            ? (_openBlock(), _createBlock(_component_el_row, {
                                key: 0,
                                style: {"width":"100%","margin-top":"15px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: serviceAddrRejectReason.value,
                                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((serviceAddrRejectReason).value = $event)),
                                    placeholder: "驳回理由",
                                    style: {"width":"auto","flex-grow":"1","margin-right":"20px"}
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    onClick: onRejectServiceAddr,
                                    disabled: "",
                                    title: "用户申请修改地址功能暂时关闭"
                                  }, {
                                    default: _withCtx(() => _cache[101] || (_cache[101] = [
                                      _createTextVNode("驳回修改")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    onClick: onAllowServiceAddr,
                                    disabled: "",
                                    title: "用户申请修改地址功能暂时关闭"
                                  }, {
                                    default: _withCtx(() => _cache[102] || (_cache[102] = [
                                      _createTextVNode("允许修改")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : (orderData.value.service_addr.status == 2)
                              ? (_openBlock(), _createBlock(_component_el_row, {
                                  key: 1,
                                  class: "mt10 color-danger bold"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" 已处理，申请处理时间： " + _toDisplayString(orderData.value.service_addr.operate_time), 1)
                                  ]),
                                  _: 1
                                }))
                              : (orderData.value.service_addr.status == 3)
                                ? (_openBlock(), _createBlock(_component_el_row, {
                                    key: 2,
                                    class: "mt10 color-danger bold"
                                  }, {
                                    default: _withCtx(() => [
                                      _cache[103] || (_cache[103] = _createTextVNode(" 已驳回申请，驳回理由: ")),
                                      _createElementVNode("span", _hoisted_18, _toDisplayString(orderData.value.service_addr.admin_reason), 1)
                                    ]),
                                    _: 1
                                  }))
                                : (orderData.value.service_addr.status == 4)
                                  ? (_openBlock(), _createBlock(_component_el_row, {
                                      key: 3,
                                      class: "mt10 color-danger bold"
                                    }, {
                                      default: _withCtx(() => _cache[104] || (_cache[104] = [
                                        _createTextVNode("用户已撤回修改")
                                      ])),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createVNode(_component_el_input, {
                            type: "textarea",
                            class: "full-width",
                            rows: 2,
                            "model-value": orderData.value.service_addr?.reason || '',
                            disabled: ""
                          }, null, 8, ["model-value"]),
                          (orderData.value.service_addr.status == 1)
                            ? (_openBlock(), _createBlock(_component_el_row, {
                                key: 0,
                                style: {"width":"100%","margin-top":"20px"}
                              }, {
                                default: _withCtx(() => [
                                  _cache[106] || (_cache[106] = _createElementVNode("span", null, "驳回理由：", -1)),
                                  _createVNode(_component_el_input, {
                                    type: "textarea",
                                    autosize: "",
                                    modelValue: serviceAddrRejectReason.value,
                                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((serviceAddrRejectReason).value = $event)),
                                    placeholder: "驳回理由",
                                    style: {"width":"auto","flex-grow":"1","margin-right":"20px"}
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    onClick: onRejectServiceAddr
                                  }, {
                                    default: _withCtx(() => _cache[105] || (_cache[105] = [
                                      _createTextVNode("驳回修改")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : (orderData.value.service_addr.status == 2)
                              ? (_openBlock(), _createBlock(_component_el_row, {
                                  key: 1,
                                  class: "mt10 color-danger bold"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" 已处理，申请处理时间： " + _toDisplayString(orderData.value.service_addr.operate_time), 1)
                                  ]),
                                  _: 1
                                }))
                              : (orderData.value.service_addr.status == 3)
                                ? (_openBlock(), _createBlock(_component_el_row, {
                                    key: 2,
                                    class: "mt10 color-danger bold"
                                  }, {
                                    default: _withCtx(() => [
                                      _cache[107] || (_cache[107] = _createTextVNode(" 已驳回申请，驳回理由: ")),
                                      _createElementVNode("span", _hoisted_19, _toDisplayString(orderData.value.service_addr.admin_reason), 1)
                                    ]),
                                    _: 1
                                  }))
                                : (orderData.value.service_addr.status == 4)
                                  ? (_openBlock(), _createBlock(_component_el_row, {
                                      key: 3,
                                      class: "mt10 color-danger bold"
                                    }, {
                                      default: _withCtx(() => _cache[108] || (_cache[108] = [
                                        _createTextVNode(" 用户已撤回修改 ")
                                      ])),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                        ], 64))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (orderData.value.brand_id == 3 || orderData.value.brand_id == 101257)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createVNode(_component_el_button, {
                    type: "success",
                    size: "small",
                    onClick: yuanzuPush
                  }, {
                    default: _withCtx(() => _cache[109] || (_cache[109] = [
                      _createTextVNode("元祖推送")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "success",
                    size: "small",
                    onClick: viewPushResult
                  }, {
                    default: _withCtx(() => _cache[110] || (_cache[110] = [
                      _createTextVNode("查看推送结果")
                    ])),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, {
          shadow: "hover",
          header: "状态信息",
          class: "mt10"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "支付状态" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: formData.pay_status,
                          "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((formData.pay_status) = $event)),
                          disabled: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              value: "0",
                              label: "未支付"
                            }),
                            _createVNode(_component_el_option, {
                              value: "1",
                              label: "已支付"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "门店状态" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: formData.shop_status,
                          "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((formData.shop_status) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              value: "0",
                              label: "未处理"
                            }),
                            _createVNode(_component_el_option, {
                              value: "1",
                              label: "已接单"
                            }),
                            _createVNode(_component_el_option, {
                              value: "2",
                              label: "制作完成"
                            }),
                            _createVNode(_component_el_option, {
                              value: "3",
                              label: "已发货"
                            }),
                            _createVNode(_component_el_option, {
                              value: "4",
                              label: "已拒绝"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "显示类型" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: formData.is_hidden,
                          "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((formData.is_hidden) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              value: "0",
                              label: "正常订单"
                            }),
                            _createVNode(_component_el_option, {
                              value: "1",
                              label: "隐藏订单"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "订单状态" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: formData.status,
                          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((formData.status) = $event)),
                          disabled: orderData.value.data.status == 3
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              value: "0",
                              label: "待分配"
                            }),
                            _createVNode(_component_el_option, {
                              value: "1",
                              label: "已分配"
                            }),
                            _createVNode(_component_el_option, {
                              value: "2",
                              label: "已完成",
                              disabled: ""
                            }),
                            _createVNode(_component_el_option, {
                              value: "3",
                              label: "已取消",
                              disabled: ""
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "订单完成类型" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: orderData.value.data.finished_type,
                          "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((orderData.value.data.finished_type) = $event)),
                          disabled: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              value: "0",
                              label: "未确认"
                            }),
                            _createVNode(_component_el_option, {
                              value: "1",
                              label: "用户"
                            }),
                            _createVNode(_component_el_option, {
                              value: "2",
                              label: "客服"
                            }),
                            _createVNode(_component_el_option, {
                              value: "3",
                              label: "自动"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "处理人" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: formData.dispose_admin_id,
                          "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((formData.dispose_admin_id) = $event)),
                          placeholder: "请选择处理人"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderData.value.admins, (admin) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: admin.id,
                                label: admin.first_name,
                                value: admin.id,
                                disabled: admin.status == -1
                              }, null, 8, ["label", "value", "disabled"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, {
          shadow: "hover",
          header: "物流与备注",
          class: "mt10"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "物流单号" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formData.express_no,
                          "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((formData.express_no) = $event)),
                          disabled: isExpressReadOnly.value,
                          title: isExpressReadOnly.value ? '已超过72小时，不能修改' : ''
                        }, null, 8, ["modelValue", "disabled", "title"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "物流名称" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formData.express_cp,
                          "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((formData.express_cp) = $event)),
                          disabled: isExpressReadOnly.value,
                          title: isExpressReadOnly.value ? '已超过72小时，不能修改' : ''
                        }, null, 8, ["modelValue", "disabled", "title"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "物流信息" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_21, [
                  (orderData.value.items.some(i => i.express_no))
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(formattedLogistics.value, (log, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: idx,
                          class: "mb5"
                        }, [
                          _createElementVNode("span", null, _toDisplayString(log.express_cp), 1),
                          _createElementVNode("span", _hoisted_22, _toDisplayString(log.express_no), 1),
                          _createVNode(_component_el_button, {
                            type: "text",
                            class: "ml20",
                            onClick: ($event: any) => (viewLogistics(log))
                          }, {
                            default: _withCtx(() => _cache[111] || (_cache[111] = [
                              _createTextVNode("查看物流信息")
                            ])),
                            _: 2
                          }, 1032, ["onClick"])
                        ]))
                      }), 128))
                    : (orderData.value.data.express_no)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("span", null, _toDisplayString(orderData.value.data.express_cp) + " " + _toDisplayString(orderData.value.data.express_no), 1),
                          _createVNode(_component_el_button, {
                            type: "text",
                            onClick: _cache[43] || (_cache[43] = ($event: any) => (viewLogistics(orderData.value.data)))
                          }, {
                            default: _withCtx(() => _cache[112] || (_cache[112] = [
                              _createTextVNode("查看物流信息")
                            ])),
                            _: 1
                          })
                        ], 64))
                      : (_openBlock(), _createElementBlock("div", _hoisted_23, "暂无物流信息")),
                  (orderData.value.data.express_no)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 3,
                        type: "text",
                        onClick: sendSms
                      }, {
                        default: _withCtx(() => _cache[113] || (_cache[113] = [
                          _createTextVNode("发送短信模板")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "用户备注" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  class: "full-width",
                  rows: 1,
                  modelValue: formData.buyer_msg,
                  "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((formData.buyer_msg) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "商家备注" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  class: "full-width",
                  rows: 1,
                  modelValue: formData.seller_msg,
                  "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((formData.seller_msg) = $event)),
                  disabled: orderData.value.brand_id != 101299
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "客服备注" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_el_input, {
                    type: "textarea",
                    class: "full-width",
                    rows: 2,
                    modelValue: formData.note,
                    "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((formData.note) = $event)),
                    maxlength: "300",
                    "show-word-limit": "",
                    disabled: isSheepOrder.value
                  }, null, 8, ["modelValue", "disabled"]),
                  (isSheepOrder.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, "薅羊毛暂停发货"))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, {
          shadow: "hover",
          header: "工单系统",
          class: "mt10"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "工单类别" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: formData.work_type,
                          "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((formData.work_type) = $event)),
                          placeholder: "请选择工单类别",
                          disabled: isWorkOrderProcessed.value
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              value: "1",
                              label: "客户投诉"
                            }),
                            _createVNode(_component_el_option, {
                              value: "2",
                              label: "客户咨询"
                            }),
                            _createVNode(_component_el_option, {
                              value: "3",
                              label: "门店咨询"
                            }),
                            _createVNode(_component_el_option, {
                              value: "4",
                              label: "其它"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "工单优先级" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: formData.work_level,
                          "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((formData.work_level) = $event)),
                          placeholder: "请选择工单优先级",
                          disabled: isWorkOrderProcessed.value
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              value: "1",
                              label: "紧急"
                            }),
                            _createVNode(_component_el_option, {
                              value: "2",
                              label: "正常"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "工单状态" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: formData.work_status,
                          "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((formData.work_status) = $event)),
                          placeholder: "请选择工单状态",
                          disabled: isWorkOrderProcessed.value
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              value: "0",
                              label: "待处理"
                            }),
                            _createVNode(_component_el_option, {
                              value: "1",
                              label: "处理中"
                            }),
                            _createVNode(_component_el_option, {
                              value: "2",
                              label: "已处理"
                            }),
                            _createVNode(_component_el_option, {
                              value: "3",
                              label: "已完结"
                            }),
                            _createVNode(_component_el_option, {
                              value: "4",
                              label: "已超时"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "延期申请状态" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: formData.reply_status,
                          "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((formData.reply_status) = $event)),
                          placeholder: "请选择延期申请状态",
                          disabled: isWorkOrderProcessed.value
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              value: "0",
                              label: "未申请"
                            }),
                            _createVNode(_component_el_option, {
                              value: "1",
                              label: "已申请"
                            }),
                            _createVNode(_component_el_option, {
                              value: "2",
                              label: "申请通过"
                            }),
                            _createVNode(_component_el_option, {
                              value: "3",
                              label: "申请驳回"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "工单内容" }, {
              default: _withCtx(() => [
                (orderData.value.all_works?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderData.value.all_works, (work, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: idx,
                          class: _normalizeClass(['work-item', work.solution ? 'right' : 'left'])
                        }, [
                          _createVNode(_component_el_input, {
                            type: "textarea",
                            class: "full-width",
                            rows: 2,
                            value: work.solution || work.work_content,
                            disabled: ""
                          }, null, 8, ["value"]),
                          (work.work_image)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(work.work_image.split(','), (img, i) => {
                                  return (_openBlock(), _createBlock(_component_el_image, {
                                    key: i,
                                    src: img,
                                    "preview-src-list": work.work_image.split(','),
                                    "preview-teleported": true,
                                    class: "work-img"
                                  }, null, 8, ["src", "preview-src-list"]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ], 2))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createVNode(_component_el_input, {
                        type: "textarea",
                        rows: 2,
                        modelValue: formData.work_content,
                        "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((formData.work_content) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(ImageUploaderDialog, {
                          modelValue: formData.work_image,
                          "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((formData.work_image) = $event)),
                          "max-count": 5,
                          accept: ".jpg,.jpeg,.png"
                        }, null, 8, ["modelValue"])
                      ])
                    ]))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "disabled"]),
    _createElementVNode("div", _hoisted_30, [
      (orderData.value.if_guangfa)
        ? (_openBlock(), _createElementBlock("span", _hoisted_31, "该订单为广发定制：非质量问题，概不退货"))
        : _createCommentVNode("", true),
      (isTestOrder.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_32, "该订单为测试订单"))
        : _createCommentVNode("", true),
      _createVNode(_component_el_button, {
        onClick: _cache[53] || (_cache[53] = ($event: any) => (_unref(router).go(-1)))
      }, {
        default: _withCtx(() => _cache[114] || (_cache[114] = [
          _createTextVNode("取消")
        ])),
        _: 1
      }),
      (!isReadOnly.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createVNode(_component_el_tooltip, {
              content: '该订单存在商品差价变动，不允许整单退款',
              placement: "top",
              disabled: !orderData.value.items?.some(item => item.adjust_price != '0.00')
            }, {
              default: _withCtx(() => [
                (canRefundOrder.value)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "primary",
                      disabled: orderData.value.items?.some(item => item.adjust_price != '0.00'),
                      onClick: onOrderRefund
                    }, {
                      default: _withCtx(() => _cache[115] || (_cache[115] = [
                        _createTextVNode("整单退款")
                      ])),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["disabled"]),
            (!isTestOrder.value && orderData.value.data.pay_status == 1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (orderData.value.all_works?.length)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "primary",
                        onClick: _cache[54] || (_cache[54] = ($event: any) => (replyDialogVisible.value = true))
                      }, {
                        default: _withCtx(() => _cache[116] || (_cache[116] = [
                          _createTextVNode("工单回复")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: submitForm
                  }, {
                    default: _withCtx(() => _cache[117] || (_cache[117] = [
                      _createTextVNode("保存")
                    ])),
                    _: 1
                  }),
                  (!orderData.value.all_works?.length)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        type: "primary",
                        onClick: submitFormWithWorkOrder
                      }, {
                        default: _withCtx(() => _cache[118] || (_cache[118] = [
                          _createTextVNode("保存且生成工单")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (orderData.value.finished_works?.length)
      ? (_openBlock(), _createBlock(_component_el_card, {
          key: 0,
          shadow: "hover",
          header: "历史工单",
          class: "mt10"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table, {
              data: orderData.value.finished_works,
              border: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "id",
                  label: "编号",
                  width: "80"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "phone_src",
                  label: "用户电话"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "type_msg",
                  label: "工单类型"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "msg",
                  label: "客户反馈"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "created_at",
                  label: "创建时间"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "created_name",
                  label: "创建人"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "finished_at",
                  label: "完成时间"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "finished_name",
                  label: "完成人"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "solution",
                  label: "处理结果"
                }),
                _createVNode(_component_el_table_column, { label: "处理状态" }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(WorkStatus[scope.row.status]), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_el_card, {
      shadow: "hover",
      header: "订单日志",
      class: "mt10"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: orderData.value.logs
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "msg",
              label: "操作内容"
            }),
            _createVNode(_component_el_table_column, {
              prop: "admin_name",
              label: "操作人",
              width: "150"
            }),
            _createVNode(_component_el_table_column, {
              prop: "created_at",
              label: "操作时间",
              width: "200"
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: fineDialogVisible.value,
      "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((fineDialogVisible).value = $event)),
      title: fineDialogTitle.value,
      width: "500px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[57] || (_cache[57] = ($event: any) => (fineDialogVisible.value = false))
        }, {
          default: _withCtx(() => _cache[119] || (_cache[119] = [
            _createTextVNode("取消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: saveFine
        }, {
          default: _withCtx(() => _cache[120] || (_cache[120] = [
            _createTextVNode("保存")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-width": "100px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "罚款金额" }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_el_input, {
                  modelValue: fineForm.fine_price,
                  "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((fineForm.fine_price) = $event)),
                  placeholder: "只能是数字"
                }, null, 8, ["modelValue"]), [
                  [_directive_decimal]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "罚款原因" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  modelValue: fineForm.fine_remark,
                  "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((fineForm.fine_remark) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: skuDialogVisible.value,
      "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((skuDialogVisible).value = $event)),
      title: "补充商品sku编码",
      width: "500px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[60] || (_cache[60] = ($event: any) => (skuDialogVisible.value = false))
        }, {
          default: _withCtx(() => _cache[121] || (_cache[121] = [
            _createTextVNode("取消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: onSaveSku
        }, {
          default: _withCtx(() => _cache[122] || (_cache[122] = [
            _createTextVNode("保存")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-width": "100px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "填写sku编码" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: skuForm.sku,
                  "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((skuForm.sku) = $event)),
                  placeholder: "请填写商品的sku编码"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: updateFineDialogVisible.value,
      "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((updateFineDialogVisible).value = $event)),
      title: "罚款记录",
      width: "800px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[62] || (_cache[62] = ($event: any) => (updateFineDialogVisible.value = false))
        }, {
          default: _withCtx(() => _cache[126] || (_cache[126] = [
            _createTextVNode("关闭")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: saveFineRecords
        }, {
          default: _withCtx(() => _cache[127] || (_cache[127] = [
            _createTextVNode("保存")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_33, [
          _cache[124] || (_cache[124] = _createElementVNode("h4", null, "不可修改记录", -1)),
          _createVNode(_component_el_table, {
            data: fineRecords.nofine_record,
            border: "",
            class: "mt10"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "id",
                label: "ID",
                width: "80"
              }),
              _createVNode(_component_el_table_column, {
                prop: "type_msg",
                label: "罚款类型"
              }),
              _createVNode(_component_el_table_column, {
                prop: "money",
                label: "罚款金额"
              }),
              _createVNode(_component_el_table_column, {
                prop: "reason",
                label: "罚款原因"
              }),
              _createVNode(_component_el_table_column, {
                prop: "created_at",
                label: "罚款时间"
              })
            ]),
            _: 1
          }, 8, ["data"]),
          _cache[125] || (_cache[125] = _createElementVNode("h4", { class: "mt30" }, "可修改记录", -1)),
          _createVNode(_component_el_table, {
            data: fineRecords.fine_record,
            border: "",
            class: "mt10"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "id",
                label: "ID",
                width: "80"
              }),
              _createVNode(_component_el_table_column, {
                prop: "type_msg",
                label: "罚款类型"
              }),
              _createVNode(_component_el_table_column, { label: "罚款金额" }, {
                default: _withCtx((scope) => [
                  _withDirectives(_createVNode(_component_el_input, {
                    modelValue: scope.row.money,
                    "onUpdate:modelValue": ($event: any) => ((scope.row.money) = $event),
                    placeholder: "只能是数字"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]), [
                    [_directive_decimal]
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, { label: "罚款原因" }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_input, {
                    modelValue: scope.row.reason,
                    "onUpdate:modelValue": ($event: any) => ((scope.row.reason) = $event)
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "created_at",
                label: "罚款时间"
              }),
              _createVNode(_component_el_table_column, { label: "操作" }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_button, {
                    type: "danger",
                    size: "small",
                    onClick: ($event: any) => (deleteFineRecord(scope.row))
                  }, {
                    default: _withCtx(() => _cache[123] || (_cache[123] = [
                      _createTextVNode("删除")
                    ])),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: logisticsDialogVisible.value,
      "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((logisticsDialogVisible).value = $event)),
      title: "物流信息",
      width: "800px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createTextVNode("物流公司：" + _toDisplayString(currentLogistics.value.express_cp), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createTextVNode("物流单号：" + _toDisplayString(currentLogistics.value.express_no), 1)
                  ]),
                  _: 1
                }),
                (currentLogistics.value.ship_time)
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 0,
                      span: 8
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("单号上传时间：" + _toDisplayString(currentLogistics.value.ship_time), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createTextVNode("收货人：" + _toDisplayString(orderData.value.data.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createTextVNode("联系方式：" + _toDisplayString(orderData.value.data.phone), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createTextVNode("下单时间：" + _toDisplayString(orderData.value.data.created_at), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createTextVNode("收货地址：" + _toDisplayString(orderData.value.data.province) + _toDisplayString(orderData.value.data.city) + _toDisplayString(orderData.value.data.area) + _toDisplayString(orderData.value.data.addr), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (currentLogistics.value.product_name)
              ? (_openBlock(), _createBlock(_component_el_row, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createTextVNode("商品信息：" + _toDisplayString(currentLogistics.value.product_name), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("span", null, "目的地：" + _toDisplayString(orderData.value.data.city), 1),
              (logisticsTraces.fromCity)
                ? (_openBlock(), _createElementBlock("span", _hoisted_38, "始发地：" + _toDisplayString(logisticsTraces.fromCity), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_el_timeline, { class: "mt10" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logisticsTraces.list, (trace, index) => {
                  return (_openBlock(), _createBlock(_component_el_timeline_item, {
                    key: index,
                    timestamp: trace.AcceptTime
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        innerHTML: formatTrace(trace.AcceptStation)
                      }, null, 8, _hoisted_39)
                    ]),
                    _: 2
                  }, 1032, ["timestamp"]))
                }), 128))
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: replyDialogVisible.value,
      "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((replyDialogVisible).value = $event)),
      title: "回复",
      width: "600px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[67] || (_cache[67] = ($event: any) => (replyDialogVisible.value = false))
        }, {
          default: _withCtx(() => _cache[128] || (_cache[128] = [
            _createTextVNode("取消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirmReply
        }, {
          default: _withCtx(() => _cache[129] || (_cache[129] = [
            _createTextVNode("确定")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-width": "100px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "回复内容" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  rows: 5,
                  modelValue: replyForm.content,
                  "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((replyForm.content) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "上传图片" }, {
              default: _withCtx(() => [
                _createVNode(ImageUploaderDialog, {
                  modelValue: replyForm.images,
                  "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((replyForm.images) = $event)),
                  "max-count": 5,
                  accept: ".jpg,.jpeg,.png"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: priceDialogVisible.value,
      "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((priceDialogVisible).value = $event)),
      title: "商品差价",
      width: "500px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[72] || (_cache[72] = ($event: any) => (priceDialogVisible.value = false))
        }, {
          default: _withCtx(() => _cache[134] || (_cache[134] = [
            _createTextVNode("取消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: savePriceDiff
        }, {
          default: _withCtx(() => _cache[135] || (_cache[135] = [
            _createTextVNode("保存")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-width": "100px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "*账户",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: priceForm.type,
                  "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((priceForm.type) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: 1 }, {
                      default: _withCtx(() => _cache[130] || (_cache[130] = [
                        _createTextVNode("余额")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 2 }, {
                      default: _withCtx(() => _cache[131] || (_cache[131] = [
                        _createTextVNode("实付")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _cache[132] || (_cache[132] = _createElementVNode("span", { class: "sub-tip" }, "注：实付由客服加、减", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "差价",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: priceForm.price_diff,
                  "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((priceForm.price_diff) = $event)),
                  placeholder: "请输入差价",
                  onInput: validatePriceDiff
                }, null, 8, ["modelValue"]),
                _cache[133] || (_cache[133] = _createElementVNode("span", { class: "sub-tip" }, "注：加差价用\"+\"，减差价用\"-\"", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "差价备注",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  modelValue: priceForm.price_remark,
                  "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((priceForm.price_remark) = $event)),
                  placeholder: "请输入差价备注"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})